
import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Focuspoint } from 'components/Focuspoint';

import { imgUrl } from 'stores/utils';
// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css"
import "swiper/components/thumbs/thumbs.min.css"

import "./ThumbsSlider.css";


// import Swiper core and required modules
import SwiperCore, {
    Navigation, Thumbs
} from 'swiper/core';

// install Swiper modules
SwiperCore.use([Navigation, Thumbs]);


const ThumbsSlider = (props) => {


    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const { images } = props;

    return (
        <div className="gallery-container">
            <Swiper style={{ '--swiper-navigation-color': '#fff', '--swiper-pagination-color': '#fff' }}
                spaceBetween={10}
                navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                watchOverflow={true}
                watchSlidesVisibility={true}
                watchSlidesProgress={true}
                preventInteractionOnTransition={true}
                className="gallery-main">
                {images.map(image =>
                    <SwiperSlide key={image.Id} >
                        <figure className="product-image">
                            <div className="spacer"></div>
                            <Focuspoint
                                src={imgUrl(image.Id)}
                                imageW={1512}
                                imageH={830}
                                focusX={0.0}
                                focusY={0.0}
                                reCalcOnWindowResize={true}
                            />
                        </figure>
                    </SwiperSlide>
                )}
            </Swiper>
            <Swiper onSwiper={setThumbsSwiper}
                direction='vertical'
                centeredSlides={true}
                centeredSlidesBounds={true}
                spaceBetween={10}
                slidesPerView={4}
                freeMode={true}
                watchSlidesVisibility={true}
                watchSlidesProgress={true}
                className="gallery-thumbs">
                {images.map(image =>
                    <SwiperSlide key={image.Id} >
                        <Focuspoint
                            src={imgUrl(image.Id)}
                            imageW={756}
                            imageH={415}
                            focusX={0.0}
                            focusY={0.0}
                            reCalcOnWindowResize={true}
                        />
                        {/* <figure className="product-image">
                            <div className="spacer"></div>
                            <img src={imgUrl(image.Id)}/>
                        </figure> */}
                    </SwiperSlide>
                )}
            </Swiper>
        </div>
    )
}

export default ThumbsSlider;